import {
  GET_PROFILE_OPERATOR_DETAIL_START,
  GET_PROFILE_OPERATOR_DETAIL_ERROR,
  GET_PROFILE_OPERATOR_DETAIL_SUCCESS,
  GET_PROFILE_OPERATOR_CLEAR_REDUCER,
} from "Constant";

const initialState = {
  loading: false,
  data: null,
};

export default function MyprofileReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case GET_PROFILE_OPERATOR_DETAIL_START:
      return {
        ...state,
        loading: true,
        data: null,
      };
    case GET_PROFILE_OPERATOR_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case GET_PROFILE_OPERATOR_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        data: null,
        message: action.error.message,
      };
    case GET_PROFILE_OPERATOR_CLEAR_REDUCER:
      return {
        ...state,
        data: null,
      };

    default:
      return state;
  }
}
